import { render } from "./caseNo.vue?vue&type=template&id=60e1b6c0&scoped=true"
import script from "./caseNo.vue?vue&type=script&lang=js"
export * from "./caseNo.vue?vue&type=script&lang=js"

import "./caseNo.vue?vue&type=style&index=0&id=60e1b6c0&scoped=true&lang=scss"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e1b6c0"]])

export default __exports__